<section
  id="verificacion"
  class="verificacion-otp"
  [class.verificacion-otp--juridica]="isJuridica && isRegistroOtp"
  [class.verificacion-otp--auth]="isAuthOtp"
  [class.verificacion-otp--auth-if]="isAuthOtp && isAuthIf"
  [class.verificacion-otp--auth-micro]="isAuthOtp && !isAuthIf"
>
  <app-header-public
    variant="v2"
    [showAuthButtons]="true"
    [showRegisterButton]="false"
  ></app-header-public>

  <div class="verificacion-otp__vigilado" aria-hidden="true">
    <img
      class="verificacion-otp__vigilado-img"
      src="assets/img/Home/hero/Ico_super.svg"
      alt=""
    />
  </div>

  @if (isRegistroOtp) {
  <main class="verificacion-otp__main">
    <span class="verificacion-otp__bubble verificacion-otp__bubble--bottom-lg" aria-hidden="true"></span>
    <span class="verificacion-otp__bubble verificacion-otp__bubble--bottom-sm" aria-hidden="true"></span>
    <div class="verificacion-otp__layout">
      <aside class="verificacion-otp__visual" aria-hidden="true">
        <span class="verificacion-otp__bubble verificacion-otp__bubble--lg"></span>
        <span class="verificacion-otp__bubble verificacion-otp__bubble--sm"></span>
        <div class="verificacion-otp__visual-frame">
          <img
            class="verificacion-otp__visual-img"
            [src]="otpImageSrc"
            [alt]="isJuridica ? 'Verificación persona jurídica' : 'Verificación persona natural'"
          />
        </div>
      </aside>

      <div class="verificacion-otp__form-col">
        <ng-container *ngTemplateOutlet="otpFormContent"></ng-container>
      </div>
    </div>
  </main>
  } @else {
  <main class="verificacion-otp__main verificacion-otp__main--auth">
    <div class="verificacion-otp__hero">
      <div
        class="verificacion-otp__bg"
        aria-hidden="true"
        [style.background-image]="'url(' + otpImageSrc + ')'"
      ></div>

      <div class="verificacion-otp__visual-mobile" aria-hidden="true">
        <span class="verificacion-otp__bubble-login verificacion-otp__bubble-login--tl-lg"></span>
        <span class="verificacion-otp__bubble-login verificacion-otp__bubble-login--tl-sm"></span>
        <img class="verificacion-otp__visual-mobile-img" [src]="otpImageMobileSrc" alt="" />
      </div>

      <span class="verificacion-otp__bubble-login verificacion-otp__bubble-login--br-lg verificacion-otp__bubble-login--desktop" aria-hidden="true"></span>
      <span class="verificacion-otp__bubble-login verificacion-otp__bubble-login--br-sm verificacion-otp__bubble-login--desktop" aria-hidden="true"></span>

      <div class="verificacion-otp__panel">
        <span class="verificacion-otp__bubble-login verificacion-otp__bubble-login--tl-lg verificacion-otp__bubble-login--desktop" aria-hidden="true"></span>
        <span class="verificacion-otp__bubble-login verificacion-otp__bubble-login--tl-sm verificacion-otp__bubble-login--desktop" aria-hidden="true"></span>
        <ng-container *ngTemplateOutlet="otpFormContent"></ng-container>
      </div>
    </div>
  </main>
  }

  <app-home-site-footer></app-home-site-footer>
</section>

<ng-template #otpFormContent>
  <h1 class="verificacion-otp__title">
    Verificación de <span>correo electrónico</span>
  </h1>

  <div class="verificacion-otp__email-block">
    @if (params?.isDesbloquear) {
      <p class="verificacion-otp__lead">
        Revisa tu correo electrónico o los mensajes enviados a tu número de celular;
        allí encontrarás un código que debes digitar a continuación para desbloquear tu usuario.
      </p>
    } @else {
      <p class="verificacion-otp__lead">
        Acabamos de enviar un código de verificación de 5 dígitos a tu correo:
      </p>
    }

    <div class="verificacion-otp__email-box" aria-live="polite">
      {{ displayEmail }}
    </div>
  </div>

  <div class="verificacion-otp__code-block">
    <p class="verificacion-otp__code-label">
      Escribe el código en el siguiente espacio
    </p>

    <div class="verificacion-otp__inputs" role="group" aria-label="Código de verificación">
      @for (otp of otpArray; track $index; let i = $index) {
        <input
          type="text"
          inputmode="numeric"
          maxlength="1"
          class="verificacion-otp__input"
          [class.verificacion-otp__input--invalid]="otpValues[i] === '' && formSubmitted"
          [(ngModel)]="otpValues[i]"
          (input)="onInputChange($event, i)"
          (keydown.backspace)="onBackspace($event, i)"
          (paste)="onPaste($event, i)"
          [attr.aria-label]="'Dígito ' + (i + 1) + ' de 5'"
        />
      }
    </div>

    <p class="verificacion-otp__timer">
      Este código de verificación es válido por
      los próximos <strong>{{ minutes }}:{{ seconds }}</strong> minutos
    </p>
  </div>

  <div class="verificacion-otp__actions">
    <button
      type="button"
      class="verificacion-otp__btn-resend"
      (click)="sendOtp()"
    >
      Enviar nuevamente
    </button>
    <button type="button" class="verificacion-otp__link-back" (click)="back()">
      Volver
    </button>
  </div>
</ng-template>

<div class="modal fade" id="correoModal" tabindex="-1" aria-labelledby="editModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="editModalLabel">¿Necesitas ayuda?, ¡Contáctanos!</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="reset()"></button>
      </div>
      <div class="modal-body-monto m-3">
        <form class="custom-form" [formGroup]="enviarForm">
          <div class="box-montos">
            <div class="mb-3 required text-start" [ngClass]="{ err: isValidForm('mensajeUsuario') }">
              <p>Descríbenos detalladamente el problema que estás presentando:</p>
              <textarea
                class="form-control"
                maxlength="200"
                style="width: 100%"
                rows="3"
                formControlName="mensajeUsuario"
                [ngClass]="{ 'is-invalid': isValidForm('mensajeUsuario') }"
                required
              ></textarea>
              <div class="invalid-feedback" style="color: #dc3545 !important">
                Campo obligatorio
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="enviarCorreo()">Enviar</button>
        <button type="button" class="btn btn-primary" (click)="reset()" data-bs-dismiss="modal">Cancelar</button>
      </div>
    </div>
  </div>
</div>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
